import {
  createStyles,
  Grid,
  Theme,
  Typography,
  withStyles,
  WithStyles,
  Button,
  Hidden,
  IconButton,
} from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import React, { Component } from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import NavBarDrawer from './NavBarDrawer';
const logo =
  'https://wa-tools-plugin.s3.ap-south-1.amazonaws.com/full_logo.png';

class NavBarMobile extends Component<Props, cState> {
  static defaultProps = {
    // name: 'AiSensy',
  };
  state = {
    drawerOpen: false,
  };
  onDrawerOpen = () => {
    this.setState({ drawerOpen: true });
  };
  onDrawerClose = () => {
    this.setState({ drawerOpen: false });
  };
  render(): React.ReactElement {
    const { classes } = this.props;
    const path = this.props.location.pathname;
    return (
      <div
      style={{ height: 100, width:'100%',display:'flex',alignItems:'center',justifyContent:'space-between' }}
    >
        {/* <Grid item>
          <IconButton onClick={this.onDrawerOpen}>
            <Menu />
          </IconButton>
        </Grid> */}
        {/* <div> */}
          <Link to="/" style={{ display: 'block', height: '34px' }}>
            <img src={logo} className={classes.logo} />
          </Link>
        {/* </div> */}
        {/* <Grid item>
          <Button 
            color="primary"
            style={{borderRadius: 25}}
            component={Link}
            to="/generate-whatsapp-link"
          >
            WhatsApp Link
          </Button>	
        </Grid> */}
        {/* <div> */}
          {/* <ActiveBtn path={path} /> */}
          <Button
            // style={{
            //   borderRadius: 25,
            //   color: 'black',
            //   fontFamily: 'Poppins',
            //   marginRight: 15,
            // }}
            style={{width:'163px',marginRight:'10px'}}
            className={classes.switchBtn}
            component={Link}
            to={path === '/' ? '/generate-template' : '/'}
          >
            {path === '/' ? 'AI Template Generator' : 'AI Ad Creative Generator'}
          </Button>
        {/* </div> */}
        <NavBarDrawer
          drawerOpen={this.state.drawerOpen}
          onDrawerClose={this.onDrawerClose}
        />
      </div>
    );
  }
}

const ActiveBtn = (props: { path: string }): React.ReactElement => {
  switch (props.path) {
    case '/generate-whatsapp-link':
      return (
        <Button
          color="primary"
          style={{ borderRadius: 25, marginRight: 20 }}
          component={Link}
          to="/generate-whatsapp-button"
          variant="outlined"
          size="small"
        >
          WhatsApp Button
        </Button>
      );
    case '/generate-whatsapp-button':
      return (
        <Button
          color="primary"
          style={{ borderRadius: 25, marginRight: 20 }}
          component={Link}
          to="/generate-whatsapp-link"
          variant="outlined"
          size="small"
        >
          WhatsApp Button
        </Button>
      );
    default:
      return (
        <Button
          color="primary"
          variant="outlined"
          style={{ borderRadius: 25, marginRight: 20 }}
          size="small"
          href="https://app.aisensy.com/signup"
          target="_blank"
        >
          Sign Up
        </Button>
      );
  }
};

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  // name: string,
  // number: string
}

interface cState {
  drawerOpen: boolean;
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: 60,
      width: '100vw',
      position: 'sticky',
      top: 0,
      left: 0,
      // backgroundColor: "#EBF5F3",
      backgroundColor: '#ffffff',
      boxShadow: 'rgb(0 0 0 /10%) 0px 0px 0.428571rem 0px',
      // backgroundColor: theme.palette.primary.main,
      // paddingLeft: theme.spacing(2),
      boxSizing: 'border-box',
      zIndex: 100,
      // color: "white"
      // boxShadow: "0px 0px 2px 2px lightgrey"
    },
    logo: {
      height: 50,
      marginRight: 50,
      [theme.breakpoints.down('md')]: {
        marginRight: 20,
        // width: 90,
        marginLeft: 10,
        height: 34,
      },
    },
    switchBtn: {
      background: 'linear-gradient(45deg,#9152f7,#685ef3,#5d06e8)',
      backgroundSize: '300% 300%',
      color: 'white',
      fontWeight: 600,
      padding: '10px 20px',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontSize: '10px',
      margin:0,
      textDecoration: 'none',
      marginRight: 50,
      animation: '$gradient 3s ease infinite',
      position: 'relative',
      overflow: 'hidden',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: '-100%',
        width: '100%',
        height: '100%',
        background:
          'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
        animation: '$shine 1.2s linear infinite',
      },
      '&:hover': {
        background: 'linear-gradient(45deg, #3730A3, #6D28D9, #3730A3)',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
      },
    },
    '@global': {
      '@keyframes gradient': {
        '0%': {
          backgroundPosition: '0% 50%',
        },
        '50%': {
          backgroundPosition: '100% 50%',
        },
        '100%': {
          backgroundPosition: '0% 50%',
        },
      },
      '@keyframes shine': {
        '0%': {
          left: '-100%',
        },
        '100%': {
          left: '100%',
        },
      },
    },
  });

export default withStyles(styles)(withRouter(NavBarMobile));
